import { post } from '../http';

export const setCurrentDatabase = async (databaseId: number) => {
  const url = process.env.NEXT_PUBLIC_FRONT_END_BASE_URL + '/api/auth/switch-database';
  return post({
    url,
    body: JSON.stringify({ currentDatabaseId: databaseId })
  });
};
